var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status",class:("status--" + _vm.type)},[_c('img',{staticClass:"img",attrs:{"src":_vm.icon,"alt":"","width":"24","height":"24"}})])}
var staticRenderFns = []

export { render, staticRenderFns }